import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import tinycolor from "tinycolor2";
import { useColorPicker } from "../../../../hooks/useColorPicker.js";
import { useHue } from "./useHue.js";
import { useSaturation } from "./useSaturation.js";
function usePicker(props) {
  const { spacing } = useTheme();
  const { swatchesPerRow, swatchesGap, swatchSize, value } = useColorPicker();
  const defaultWidth = computeRowWidth(Math.min(swatchesPerRow, 8), Number.parseInt(spacing(swatchesGap)), swatchSize);
  const { saturationSize, hueSize } = props;
  const [selfColor, setSelfColor] = useState(() => tinycolor(value));
  const hue = useHue({
    initialSize: hueSize,
    selfColor,
    setSelfColor,
    defaultWidth
  });
  const saturation = useSaturation({
    initialSize: saturationSize,
    selfColor,
    setSelfColor,
    defaultWidth
  });
  useEffect(() => {
    setSelfColor((prevSelfColor) => {
      if (prevSelfColor.toHexString() === value) return prevSelfColor;
      return tinycolor(value);
    });
  }, [value]);
  return {
    hue,
    saturation
  };
}
function computeRowWidth(swatchPerRow, gridGapPx, chipSize) {
  return swatchPerRow * chipSize + (swatchPerRow - 1) * gridGapPx;
}
export {
  usePicker
};
//# sourceMappingURL=usePicker.js.map
